// extracted by mini-css-extract-plugin
export default {"variablesDialog":"VariablesDialog-module__variablesDialog__IciFg62","DialogOverflowWrapper":"VariablesDialog-module__DialogOverflowWrapper__lDOyIZw"};